import { createSlice } from '@reduxjs/toolkit';

const setThemeCss = (theme) => {
  if (theme === 'NCP') {
    document.documentElement.style.setProperty('--color-side-bar', '#FCDB38');
    document.documentElement.style.setProperty('--primary-bg-color', '#FFFFFF');
    document.documentElement.style.setProperty('--secondary-bg-color', '#FFFFFF');
    document.documentElement.style.setProperty('--custom-bold-font', 'ConduitITC-Bold, san-serif');
    document.documentElement.style.setProperty('--secondary-font-color', '#FFFFFF');
    document.body.style.fontFamily = 'ConduitITC-Regular, Montserrat';
    document.documentElement.style.setProperty('--custom-bold-font', 'ConduitITC-Bold, san-serif');
    document.documentElement.style.setProperty('--color-dash-card-bg', '#F1F1F2');
    document.documentElement.style.setProperty('--color-panel-card-bg', '#00000');
  }
  if (theme === 'EVC') {
    document.documentElement.style.setProperty('--color-side-bar', '#fc5d5d');
    document.documentElement.style.setProperty('--primary-bg-color', '#FAFAFA');
    document.documentElement.style.setProperty('--secondary-font-color', '#fc5d5d');
    document.body.style.fontFamily = 'DM Sans, Montserrat';
    document.documentElement.style.setProperty('--custom-bold-font', 'DM Sans, san-serif');
    document.documentElement.style.setProperty('--color-dash-card-bg', '#FFFFFF');
    document.documentElement.style.setProperty('--color-panel-card-bg', '##F6F6F6');
  }
};

const initialState = {
  user: null,
};

const userSlice = createSlice({
  name: 'user',
  themeSelect: null,
  initialState,
  reducers: {
    login: (state, action) => {
      state.user = action.payload;
      if (state.user && state.user.email.includes('@ncp')) {
        state.themeSelect = 'NCP';
        setThemeCss('NCP');
      } else {
        state.themeSelect = 'EVC';
        setThemeCss('EVC');
      }
    },
    logout: (state) => {
      state.user = null;
    },
    changeTheme: (state, action) => {
      console.log(action.payload);
      if (action.payload === 'NCP') {
        state.themeSelect = 'NCP';
        setThemeCss('NCP');
      } else {
        state.themeSelect = 'EVC';
        setThemeCss('EVC');
      }
    },
  },
});

export const { login, logout, changeTheme } = userSlice.actions;
export default userSlice.reducer;
